import React, { memo } from "react";
import { SiGoogle } from "react-icons/si";

import { NodeCard, NodeHandle, useNodeStyles } from "./nodeKit";

export default memo(({ data, isConnectable, id }) => {
  const classes = useNodeStyles();

  return (
    <NodeCard color="#db4437" icon={<SiGoogle />} title="Gemini" id={id}>
      <NodeHandle type="target" isConnectable={isConnectable} />
      <div className={`${classes.slot} ${classes.ellipsis}`}>Google AI Assistant</div>
      <NodeHandle type="source" id="a" isConnectable={isConnectable} />
    </NodeCard>
  );
});
